import { ImageElementType } from 'polotno/model/image-model';

export const getFullAvatarData = (avatarElement: ImageElementType | undefined) => {
    if (!avatarElement) return {};

    const { x: currentX, y: currentY, width: currentWidth, height: currentHeight } = avatarElement;

    const originalWidth = avatarElement?.custom?.originalWidth;
    const originalHeight = avatarElement?.custom?.originalHeight;

    const center = {
        x: currentX + currentWidth / 2,
        y: currentY + currentHeight / 2,
    };

    const ratioX = currentWidth / originalWidth;
    const ratioY = currentHeight / originalHeight;
    const ratio = Math.min(ratioX, ratioY);

    const widthWithRatio = originalWidth * ratio;
    const heightWithRatio = originalHeight * ratio;

    return {
        x: center.x - currentWidth / 2,
        y: center.y - currentHeight / 2,
        width: widthWithRatio,
        height: heightWithRatio,
    };
};
